// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"Search_FullWidth__RBiGA","FormLabel":"Search_FormLabel__V_ulx"};